export const DOCS_VERSION_KEY = "docs:version";

export const getLocalStorageDocsVersion = () => {
  return localStorage.getItem(DOCS_VERSION_KEY) ?? "";
};

export const setLocalStorageDocsVersion = (version: string) => {
  localStorage.setItem(DOCS_VERSION_KEY, version);
};
